import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft, Mail, Phone } from 'lucide-react';
import { contactInfo } from '../mock';
import './PaymentResult.css';

const PaymentCancel = () => (
  <div className="payment-result-page">
    <div className="payment-result-card">
      <div className="payment-result-icon cancelled">
        <XCircle size={56} strokeWidth={1.6} />
      </div>
      <h1>Paiement annulé</h1>
      <p>Pas de souci, aucun débit n'a été effectué. Vous pouvez retenter le paiement ou nous contacter pour toute question.</p>

      <div className="payment-result-contact">
        <div className="prc-title">Une question ? Contactez Nolan</div>
        <a href={`mailto:${contactInfo.email}`} className="prc-item"><Mail size={18} /> {contactInfo.email}</a>
        <a href="tel:+33669477536" className="prc-item"><Phone size={18} /> {contactInfo.phone}</a>
      </div>

      <Link to="/" className="payment-result-back">
        <ArrowLeft size={16} /> Retour aux offres
      </Link>
    </div>
  </div>
);

export default PaymentCancel;
